import type { I18n } from '../../i18n/I18nProvider';

type FailureWithStatus = Error & { status?: number };

/**
 * Turns a sign-in failure into something a patient can act on: wrong
 * credentials say so plainly, a dead connection blames the connection, and
 * anything the server explained keeps the server's own words.
 */
export function loginErrorMessage(error: unknown, t: I18n['t']): string {
  if (error instanceof Error) {
    const status = (error as FailureWithStatus).status;
    if (status === 401 || status === 403) return t('auth.invalidCredentials');
    // fetch() rejects with a TypeError when the request never reached a server.
    if (status === undefined && error instanceof TypeError) return t('common.error.network');
    if (error.message.trim()) return error.message;
  }
  return t('auth.genericError');
}
